import styled from '@emotion/styled'
import { H5 } from 'library/atoms/Typography'
import React from 'react'
import Icon from 'shared/library/atoms/Icon'
import Text from 'library/atoms/Typography/Text'
import Divider from 'shared/library/atoms/Divider'
import { OptionalExtra } from 'shared/helpers/formatOptionalExtraData/formatOptionalExtras'

interface GiftSummaryProps {
  adultsGoing?: number
  childrenGoing?: number
  optionalExtras?: OptionalExtra[]
}

const GiftSummary = ({
  adultsGoing,
  childrenGoing,
  optionalExtras
}: GiftSummaryProps) => {
  return (
    <StyledBox>
      <StyledHeading>
        <Icon name="voucher" size={30} color="gold" mr={2} />
        <H5>In your gift:</H5>
      </StyledHeading>
      {/**
       * Need to use ternary here rather than guard as otherwise it renders a zero
       */}
      {adultsGoing ? (
        <StyledSummaryRowText>{adultsGoing}x adults</StyledSummaryRowText>
      ) : null}
      {childrenGoing ? (
        <StyledSummaryRowText>{childrenGoing}x children</StyledSummaryRowText>
      ) : null}
      <Divider mt={undefined} mb={0} />
      {optionalExtras
        ? optionalExtras?.map(optionalExtra => (
            <StyledSummaryRowText key={optionalExtra.id}>
              {optionalExtra.quantity}x {optionalExtra.name}
            </StyledSummaryRowText>
          ))
        : null}
    </StyledBox>
  )
}

export default GiftSummary

const StyledBox = styled.section(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.mixins.pxSpread([theme.space[5], theme.space[4]]),
  border: theme.border,
  background: theme.colors.white,
  borderRadius: theme.radii[3],
  '& + &': {
    marginTop: theme.space[4]
  },
  '& > *:not(div)': {
    marginTop: theme.space[4]
  }
}))

const StyledHeading = styled.div(() => ({
  display: 'flex',
  alignItems: 'center'
}))

const StyledSummaryRowText = styled(Text)(({ theme }) => ({
  color: theme.colors.text.tertiary,
  '& + &': {
    marginTop: theme.space[4]
  }
}))
